import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import RecentOrder from './RecentOrder';
import styled from 'styled-components';
import Button from 'shared/Button';

const JQUERY_URL = "https://ajax.googleapis.com/ajax/libs/jquery/1.5.1/jquery.min.js";

class RecentOrders extends Component {
    sidekick = null;

    constructor(props) {
        super(props);

        this.state = {
            orders: [],
            sidekick: null,
            currentOrder: 0,
        }
    }

    componentDidMount() {
        if(this.props.purchaseUser) {
            this.getRecentOrders();
        }

        if(typeof Sidekick === "undefined") { // eslint-disable-line
            var jqScript = document.createElement('script');
            jqScript.src = JQUERY_URL;

            jqScript.addEventListener('load', () => {
                var sidekickScript = document.createElement('script');
                sidekickScript.src = this.props.adminUrl+'/js/sidekick.js';

                sidekickScript.addEventListener('load', () => {
                    this.sidekick = Sidekick; // eslint-disable-line
                    this.setState({sidekick: Sidekick}); // eslint-disable-line
                });

                document.body.appendChild(sidekickScript);
            });

            document.body.appendChild(jqScript);
        } else {
            this.sidekick = Sidekick; // eslint-disable-line
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.purchaseUser !== this.props.purchaseUser) {
            this.getRecentOrders();
        }
    }

    getRecentOrders = () => {
        if(!this.props.purchaseUser) {
            return;
        }

        let req = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-API-Token': this.props.apiToken,
            },
        };

        return fetch(this.props.apiUrl + '/kiosks/recentOrders/'+this.props.purchaseUser, req).then((res) => {
            if(res.status === 200) {
                return res.json();
            }
        }).then((res) => {
            this.setState({orders: res.orders});
        }).catch((e) => {});
    }

    render() {
        return(
            <RecentOrdersContainer className="kiosk__management__recent-orders">
                <RecentOrdersLabel className="recent-orders__label">
                    <span>Recent Orders</span>
                </RecentOrdersLabel>
                <RecentOrdersList className="recent-orders__list">
                    {this.renderOrders()}
                </RecentOrdersList>
            </RecentOrdersContainer>
        )
    }

    renderOrders = () => {
        if(this.state.orders.length === 0) {
            return <RecentOrderEmptyText>No recent orders</RecentOrderEmptyText>
        }

        let order = this.state.orders[this.state.currentOrder];

        return <Fragment>
            <div className="card-group">
                <div className="card">
                    <div className="button--group">
                        <Button className="button button--block" onClick={this.previousOrder} disabled={this.state.currentOrder === 0}>Previous</Button>
                        <Button className="button button--block" onClick={this.nextOrder} disabled={this.state.currentOrder === this.state.orders.length - 1}>Next</Button>
                    </div>
                </div>
                <div className="card">
                    <RecentOrder
                    reserved={order.reserved}
                    id={order.id}
                    tickets={order.tickets}
                    confirmation={order.confirmation}
                    sidekick={this.sidekick}
                    apiUrl={this.props.apiUrl}
                    kioskOptions={this.props.kioskOptions}
                    />
                </div>
            </div>
        </Fragment>
    }

    previousOrder = () => {
        this.setState({currentOrder: this.state.currentOrder - 1});
    }

    nextOrder = () => {
        this.setState({currentOrder: this.state.currentOrder + 1});
    }
}

RecentOrders.propTypes = {
    purchaseUser: PropTypes.any.isRequired,
    apiUrl: PropTypes.string.isRequired,
}

RecentOrders.defaultProps = {
}

export default RecentOrders;


const RecentOrdersContainer = styled.div`
    display: flex;
    padding: 20px 30px;
    // margin-bottom: 85px;
    border-top: 1px solid #eeeeee;
`
const RecentOrdersLabel = styled.div`
    width: 150px;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
`
const RecentOrdersList = styled.div`
    font-size: 15px;
    flex: auto;
`
const RecentOrderEmptyText = styled.span`
    font-size: 14px;
    line-height: 1.35714286;
    color: #6A6A6A;
`
